export * from "./Sofa.enums";

export const initialToken: string = "";
